import * as React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

import SignIn from '~/pages/SignIn';
import SendEmail from '~/pages/SignIn/sendEmail';
import NewRegister from '~/pages/SignIn/newRegister';
import SucessRegister from '~/pages/SignIn/sucessRegister';
import Login from '~/pages/SignIn/login';
import ForgetPassword from '~/pages/SignIn/forgetPassword';
import MyProperties from '~/pages/MyProperties';
import MyAccount from '~/pages/MyAccount';
import ChangePassword from '~/pages/MyAccount/changePassword';
import ChangeProfileSuccess from '~/pages/MyAccount/changeProfileSuccess';
import ChangePasswordSuccess from '~/pages/MyAccount/changePasswordSuccess';
import Property from '~/pages/Property';
import SecondBillet from '~/pages/SecondBillet';
import FAQ from '~/pages/FAQ';
import ReservationFund from '~/pages/ReservationFund';
import RepairRequest from '~/pages/RepairRequest';
import FinancialSummary from '~/pages/FinancialSummary';
import Statement from '~/pages/Statement/new_index';
import Calendary from '~/pages/Calendary';
import MyAds from '~/pages/MyAds';
import RequestSent from '~/pages/MyAds/requestSent';
import PropertyStatus from '~/pages/PropertyStatus';
import IncomeTax from '~/pages/IncomeTax';
import Contestacao from '~/pages/Contestation';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/NovoRegistro" component={SendEmail} />
      <Route path="/NovoCadastro" component={NewRegister} />
      <Route path="/RegistroSucesso" component={SucessRegister} />
      <Route path="/Login" component={Login} />
      <Route path="/RecuperarSenha" component={ForgetPassword} />
      <Route path="/MeusImoveis" component={MyProperties} isPrivate />
      <Route path="/MinhaConta" component={MyAccount} isPrivate />
      <Route path="/AlterarSenha" component={ChangePassword} isPrivate />
      <Route path="/Imovel" component={Property} isPrivate />
      <Route path="/SegundaViaBoleto" component={SecondBillet} isPrivate />
      <Route path="/FAQ" component={FAQ} isPrivate />
      <Route path="/FundoDeReserva" component={ReservationFund} isPrivate />
      <Route path="/SolicitarReparo" component={RepairRequest} isPrivate />
      <Route path="/ResumoFinanceiro" component={FinancialSummary} isPrivate />
      <Route path="/Extrato" component={Statement} isPrivate />
      <Route path="/Calendario" component={Calendary} isPrivate />
      <Route path="/MeusAnuncios" component={MyAds} isPrivate />
      <Route path="/SolicitaçãoEnviada" component={RequestSent} isPrivate />
      <Route path="/StatusImovel" component={PropertyStatus} isPrivate />
      <Route path="/ImpostoDeRenda" component={IncomeTax} isPrivate />
      <Route path="/Contestacao" component={Contestacao} isPrivate />
      <Route
        path="/AlterarSenhaSucesso"
        component={ChangePasswordSuccess}
        isPrivate
      />
      <Route
        path="/AtualizarDadosSucesso"
        component={ChangeProfileSuccess}
        isPrivate
      />

      <Route path="/" component={() => <h1>404</h1>} />
    </Switch>
  );
}
